module.exports = __webpack_public_path__ + "static/media/sunrise-logo.fc8a79e5.png";